import { render, staticRenderFns } from "./AudioComponent.vue?vue&type=template&id=5731229d"
import script from "./AudioComponent.vue?vue&type=script&lang=ts"
export * from "./AudioComponent.vue?vue&type=script&lang=ts"
import style0 from "./AudioComponent.vue?vue&type=style&index=0&id=5731229d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCardText,VCardTitle,VCheckbox})
